import { departementsEtRegions } from "../data/departements";
import { KATA_ROLE_OPTIONS } from "../data/kataOptions";

export const cn = (...classes) =>
  classes.filter(Boolean).join(" ");

export const normalizeDepartmentCode = (value) => {
  if (value === undefined || value === null) {
    return "";
  }

  const normalized = String(value).trim().toUpperCase();

  if (/^\d$/.test(normalized)) {
    return normalized.padStart(2, "0");
  }

  return normalized;
};

export const getDepartmentByCode = (code) => {
  const normalizedCode = normalizeDepartmentCode(code);

  return departementsEtRegions.find(
    (item) =>
      normalizeDepartmentCode(item.code) === normalizedCode
  );
};

export const getDepartmentLabel = (code) => {
  const department = getDepartmentByCode(code);

  return department
    ? `${department.code} · ${department.departement}`
    : normalizeDepartmentCode(code);
};

export const getRegions = () =>
  [...new Set(departementsEtRegions.map((item) => item.region))]
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, "fr"));

export const getDepartmentsForRegion = (region) => {
  const items = region
    ? departementsEtRegions.filter(
        (item) => item.region === region
      )
    : departementsEtRegions;

  return [...items].sort((a, b) =>
    a.departement.localeCompare(b.departement, "fr")
  );
};

export const getRoleLabel = (role) =>
  KATA_ROLE_OPTIONS.find((item) => item.value === role)
    ?.shortLabel || "Tori ou Uke";

export const truncateText = (value, maxLength = 180) => {
  const text = String(value || "").trim();

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.slice(0, maxLength).trim()}…`;
};

export const formatDate = (value) => {
  if (!value) {
    return "";
  }

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(new Date(value));
};

export const getInitials = (prenom, nom) =>
  `${String(prenom || "").charAt(0)}${String(nom || "").charAt(0)}`
    .toUpperCase();

export const sanitizePhoneForLink = (phone) =>
  String(phone || "").replace(/[^\d+]/g, "");